import styled, { keyframes } from "styled-components"
import { Link } from "react-router-dom"
import { FiArrowLeft, FiTrash2, FiAlertTriangle } from "react-icons/fi"

const FadeInAnimation = keyframes`
    from {
        opacity: 0;
        transform: translateY(100px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

export const Icon = styled.button`
  position: fixed;
  top: 88px;
  left: 1.5rem;
  font-size: 2rem;
  cursor: pointer;
  width: 48px;
  height: 48px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  z-index: 9;
  border: none;
  outline: none;
  background: #fff;
  cursor: pointer;

  @media screen and (max-width: 768px) {
    top: 88px;
    left: 1.5rem;
    z-index: 99;
  }
`

export const LeftIcon = styled(FiArrowLeft)`
  color: #202020;
  width: 24px;
  height: 24px;
  position: relative;
`

export const NavContainer = styled.nav`
  width: 100%;
  /* max-width: 1440px; */
  height: 65px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  position: sticky;
  top: 0;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
`

export const NavLogo = styled(Link)`
  width: 32px;
  transform: translateY(3px);
  cursor: pointer;
`

export const NavButton = styled.div`
  text-align: center;
`

export const ProductDetailContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`

export const ProductDetailWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "productImageContainer productInfoContainer";

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "productImageContainer"
      "productInfoContainer";
  }
`

export const ProductImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: flex-start;
  padding: 24px;
  grid-area: productImageContainer;
  animation: ${FadeInAnimation} 0.8s forwards cubic-bezier(0.2, 0.8, 0.2, 1);

  @media screen and (max-width: 375px) {
    align-items: center;
    padding: 16px;
  }
`

export const BigImageWrap = styled.div`
  background: #f0f0f0;
  border-radius: 20px;
  width: 100%;
  /* height: 100%; */
  position: relative;

  @media screen and (max-width: 375px) {
    width: 100%;
    margin: 0 16px;
  }
`

export const ImageOverflowWrap = styled.div`
  border-radius: 20px;
  overflow: hidden;
  height: 100%;
`

export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
`

export const SmallImageWrap = styled.div`
  display: flex;
  width: 100px;
  background: #f0f0f0;
  border-radius: 12px;
  transition: all 0.3s ease-in-out;
  margin: 16px 16px 0 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;

  &:hover {
    transform: translateY(-4px);
  }

  @media screen and (max-width: 768px) {
    width: 90px;
  }

  @media screen and (max-width: 375px) {
    width: 80px;
  }
`

export const Img = styled.img`
  width: 100%;
  height: 100%;
`

export const ReferenceOnlyP = styled.p`
  margin-top: 16px;
  padding: 12px;
  font-size: 12px;
  color: #565656;
  background: #fafafa;
  border-radius: 8px;
`

export const RemarksP = styled.p`
  padding: 12px;
  font-size: 12px;
  color: #565656;
  background: #fdf5cb;
  border-radius: 8px;
`

export const ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: productInfoContainer;
  padding: 24px;
  animation: ${FadeInAnimation} 1.6s forwards cubic-bezier(0.2, 0.8, 0.2, 1);

  @media screen and (max-width: 768px) {
    padding: 24px;
  }

  @media screen and (max-width: 375px) {
    padding: 16px;
  }
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: #202020;
`

export const Description = styled.p`
  font-size: 14px;
  color: #565656;
`

export const CakePrice = styled.p`
  font-weight: 600;
  margin-bottom: 16px;
  color: #202020;
`

export const DTSelectorWrapper = styled.div`
  margin-top: 24px;
  display: grid;
`

export const TwoColumnInOneRow = styled.div`
  width: auto;
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`

export const AddToCartButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  border-radius: 4px;
  border: none;
  color: #202020;
  font-size: 14px;
  font-weight: 600;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background: #f8b0bb;
  margin-top: 24px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #ff91a2;
  }

  @media screen and (max-width: 480px) {
    height: 44px;
    width: 100%;
  }
`

export const IngredientAndInfoContainer = styled.div`
  height: 600px;
  background: #fafafa;
  display: flex;
  justify-content: center;
`

export const ChefImageWrap = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(24px) translateY(-24px);
  width: 100px;
`

export const PremiumImageWrap = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(16px) translateY(-16px);
  width: 90px;
`

export const NewImageWrap = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(16px) translateY(-16px);
  width: 90px;
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: red;
`

export const TopperContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 16px;
  margin: 16px 0px;
  width: 100%;
  position: relative;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`

export const TopperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  border-radius: 12px;
  cursor: pointer;
  overflow: hidden;
`

export const AddonTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #202020;
  margin-top: 16px;
`

export const AddonSectionTitle = styled.p`
  font-size: 16px;
`

export const AddonSelectionWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 16px;
  padding-bottom: 16px;
`

export const AddonSelectionP = styled.p`
  font-size: 14px;
  color: #565656;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
  }
`

export const DeleteIcon = styled(FiTrash2)`
  color: #f8b0bb;
  width: 24px;
  height: 24px;
  margin-left: 4px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-2px);
  }
`

export const AddonCardWrapper = styled.div`
  margin-top: 24px;
`

export const AlertMessage = styled.div`
  font-size: 12px;
  color: red;
  display: flex;
  align-items: center;
  margin-top: 8px;
`

export const AlertIcon = styled(FiAlertTriangle)`
  color: red;
  width: 18px;
  height: 18px;
  margin-right: 4px;
`

// export const ImgWrap = styled.div
//     background: #F0F0F0;
//     border-radius: 20px;
// `

// export const Img = styled.img`
//     width: 100%;
//     display: flex;
//     align-items: center;

//     &:hover {
//         transform: translateY(-1px) scale(1.05);
//         transition: all 0.9s ease-in-out;

//         @media screen and (max-width: 480px) {
//             transform: unset;
//         }
//     }
// `
